import React from "react";
import cx from "classnames";
import styles from "./tagList.module.scss";

interface TagListProps {
  tags: string[];
  maxVisible?: number;
  className?: string;
}

export const TagList: React.FC<TagListProps> = ({ tags, maxVisible = 2, className }) => {
  const visibleTags = tags.slice(0, maxVisible);
  const remainingCount = tags.length - maxVisible;
  const items = remainingCount > 0 ? [...visibleTags, `+${remainingCount} more`] : visibleTags;

  return (
    <>
      {items.map((item, index) => (
        <React.Fragment key={item}>
          <span className={cx(styles.tag, className)}>{item}</span>
          {index < items.length - 1 && <div className={styles.verticalLine} />}
        </React.Fragment>
      ))}
    </>
  );
};
